import { z } from "zod";

export const LoginSchema = z.object({
	username: z.string().min(1, "Username is required").max(120),
	password: z.string().min(1, "Password is required").max(512),
});

export type LoginInput = z.infer<typeof LoginSchema>;
